'use client';

import ErrorTemplate from './error-template';

export default function NotFound() {
  return (
    <ErrorTemplate headerTitle="404 error" pageTitle="Page not found">
      <p>It may have moved or no longer exists.</p>
      <p>
        Press the back button above to return to your last point and try again
        or return to the homepage to raise an issue.
      </p>
    </ErrorTemplate>
  );
}
